
import Vue from "vue";
import { Component, Watch, Provide } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import IconButton from "@/components/UI/IconButton.vue";
import PanelHeader from "@/components/Reusable/Util/PanelHeader.vue";
import IconInput from "@/components/Reusable/CustomInputs/IconInput/IconInput.vue";
import {
  configStore,
  singularityStore,
  uiStore
} from "@/store/store";
import NiceButton from "@/components/UI/NiceButton.vue";
import ControlsTree from "@/components/Reusable/ControlsTree/ControlsTree.vue";
import { editingElementControlsTreeContext } from "@/lib/components/controls";

@Component({
  components: {
    TextInput,
    Dropdown,
    IconButton,
    PanelHeader,
    IconInput,
    NiceButton,
    ControlsTree
  }
})
export default class ContentPropertiesEditor extends Vue {

  get contentSections() {
    if (!uiStore.activeElement) return null;
    return configStore.element(uiStore.activeElement.data.type).controls.contentSections;
  }

  @Provide("context")
  editingElementControlsTreeContext = editingElementControlsTreeContext;

  get contentPropertiesEditorPanelState() {
    return singularityStore.contentPropertiesEditorPanelState;
  }

  close() {
    alert("close");
  }

  backToPageStructurePanel() {
    singularityStore.setSingularityLeftPanel("page_structure");
  }

}
